
import * as API from './'

export default {
  // 获取文章列表
  getArticleList: params => {
    return API.GET('Article/Lists', params)
  },
  // 获取文章详情
  getArticleDate: params => {
    return API.GET('Article/Detail', params)
  },
  // 文章分类
  getArticleCat: params => {
    return API.GET('Articlecat/index', params)
  },
  // 根据文章分类id获取文章总条数
  getArticleTotal: params => {
    return API.GET('Article/Total', params)
  },
  // 轮播图列表
  getBannerList: params => {
    return API.GET('Banner/index', params)
  },
  // 友情链接
  getFriendlink: params => {
    return API.GET('Friendlink/index', params)
  },
  // 获取网站系统参数配置
  getSystem: params => {
    return API.GET('System/index', params)
  },
  // 获取所有的文章
  getAllArticle: params => {
    return API.GET('Article/ALists', params)
  },
  // 添加留言信息
  getAddBorad: params => {
    return API.POST('Board/add', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/service.js